import $ from "jquery";

import itemsIcons from "../../data/itemsIcons";
import MpIcon from "../utils/MpIcons";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination  } from 'swiper';
import { FaRoad, FaWalking, FaCar } from "react-icons/fa";
import { CgArrowsExpandRight } from "react-icons/cg";

// Import Swiper styles
import "swiper/css";
// import "swiper/css/pagination";

const MainPanelCarousel = ({ data }) => {
  const { icon } = $.isEmptyObject(data) ? (
    <MpIcon name="fireStation" size="sm" />
  ) : (
    itemsIcons.find((item) => item.id === data.id)
  );

  return (
    <>
      <Swiper
        className="mp-carousel"
        // pagination={true}
        mousewheel={true}
        // modules={[Pagination]}
        style={{ padding: "0 2.3rem" }}
        spaceBetween={20}
        slidesPerView={2}
      >
        {$.isEmptyObject(data) ? null : data.id == 201 ? (
          <div className="mp-name mb-2 mt-2">
            <p className="f-Bold f-14px mb-0">ترافیک نیمه سنگین</p>
          </div>
        ) : data.id == 203 ? (
          <div className="mp-name mb-2 mt-2">
            {data.value[0].state && data.value[0].name ? (
              <p className="f-Bold f-14px mb-0">
                {data.value[0].state && data.value[0].name}
              </p>
            ) : null}
            {data.value[1].state && data.value[1].name ? (
              <p className="f-Bold f-14px mb-0">
                {data.value[1].state && data.value[1].name}
              </p>
            ) : null}
          </div>
        ) : (
          data.value.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="main-panel-carousel-card py-2">
                <div className="mp-num mb-2">
                  <span className="f-Bold f-12px p-1 gray">{index + 1}</span>
                </div>

                {icon}

                <div className="mp-name mb-2 mt-2">
                  <p className="f-Bold f-14px mb-0">{item.name}</p>
                </div>
                <div className="mp-props">
                  <div className="mp-prop">
                    <CgArrowsExpandRight />
                    <p className="f-Medium f-12px mb-0">
                      فاصله: {Math.ceil(item.dist)} متر
                    </p>
                  </div>

                  <div className="mp-prop">
                    <FaCar />
                    <p className="f-Medium f-12px mb-0">زمان رسیدن: 5 دقیقه</p>
                  </div>

                  <div className="mp-prop">
                    <FaWalking />
                    <p className="f-Medium f-12px mb-0">زمان رسیدن: 20 دقیقه</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))
        )}
        {}
      </Swiper>
    </>
  );
};

export default MainPanelCarousel;
